<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <v-select
          :items="options_service_categories"
          label="Category"
          v-model="category_id"
          v-on:change="onChangeCategory"
           item-text="service_category_name"
          item-value="id"
          single-line
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <!-- <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
      <div class="d-flex">
        <v-select
        :disabled="!category_id"
        style=" max-width: 150px;"
          :items="option_filter"
          label="Select"
          v-model="searchCategory"
          @change="search=''"
           item-text="text"
          item-value="value"
        
          class="ma-2"
        hide-details
        >
        </v-select>
      <v-text-field
        :disabled="!searchCategory"
        v-model="search"
        label="Search"
          class="ma-2"
        single-line
        hide-details
      >
      </v-text-field>
        <v-btn :disabled="!search" class="mt-5"  small color="primary" @click="searchButton"> <v-icon>mdi-magnify</v-icon> </v-btn>
        <v-btn v-if="searchValue" class="mt-5 ml-1" dark small color="red" @click="clearSearchButton">Clear</v-btn>
    </div>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
      :options.sync="options"
      :server-items-length="totalDataTable"
      :page="page"
      :pageCount="numberOfPages"
      :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
     > 
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.service_master_code}}</td>
            <td>{{item.service_master_name}}</td>
            <td>{{item.service_master_lts}}</td>
            <td><span style="float: left; ">Rp.</span><span style="float:right;">
              {{formatPrice(item.service_category_standard_cost)}}</span>
            </td>
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        options_service_categories:[],
        category_id: null,
        brand_id: null,
         mounted: true,
        loadTable: false,
        page: 1,
        options: {},
        totalDataTable: 0,
        numberOfPages: 0,
        searchValue:null,
        searchCategory:null,
        search: '',
        headers: [
         { text: 'Service Code.', value: 'service_master_code' },
          { text: 'Service Name', value: 'service_master_name' },
          { text: 'Lts', value: 'service_master_lts', align: 'center' },
          { text: 'Unit Price', value: 'service_category_standard_cost', align: 'center' },
        ],
         option_filter: [ { text: 'Service Code', value: 'service_master_code' },
          { text: 'Service Name', value: 'service_master_name' },
          ],
        table: [],
      }
    },
    watch: {
    options: {
      handler() {
        if (!this.mounted && this.category_id) {
          this.onChangeCategory();
        }
      },
    },
    deep: true,
  },
  async mounted() {
    this.mounted = false

    },
    async created() {
      
     this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan

    async getList() {
      console.log("aaaaaaaaa");
      if (await Object.keys(this.$store.getters["workshop_service_categories/list"]).length == 0) {
         await this.$store.dispatch("workshop_service_categories/list")
          
      }
      
      this.options_service_categories = await this.$store.getters["workshop_service_categories/list"]
      this.loadTable= false
    },



    async onChangeCategory() { 

      this.loadTable = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      console.log(this.options);
      let pageNumber = page;

      let itemsPerPageNumber = itemsPerPage;

      var query = { page: { number: pageNumber, size: itemsPerPageNumber } };
      query.filter = { service_category_code: this.category_id };
      if (sortBy.length != 0) {
        var sort = sortBy[0];
        if (sortDesc[0]) {
          sort = "-" + sortBy[0];
        }
        query.sort = sort;
      }

      if (this.searchValue && this.searchCategory) {
          
          
           if (query.filter) {
              Object.assign(query.filter, { [this.searchCategory]: this.searchValue});
            } else {
             
            query.filter = { [this.searchCategory]: this.searchValue };
            
            }
            
      }
      console.log(query.page.number);

    

     

      
      
         await this.$store.dispatch("workshop_service_master/list", query);
      this.table = await this.$store.getters["workshop_service_master/list"];
      var pageMeta = await this.$store.getters["workshop_service_master/page"];

      
      
      this.totalDataTable = pageMeta.total;
      this.numberOfPages = pageMeta["to"];
      this.loadTable = false;
    },

     searchButton(){
       this.options.page = 1;
      this.searchValue = this.search
      this.onChangeCategory()
    },
    clearSearchButton(){
       this.options.page = 1;
      this.searchValue = null
      this.search = null
      this.searchCategory = null
      this.onChangeCategory()
    },


    //fungsi yang ada di parent di panggil saat memilih row di table
     onSelect (item) {
     this.$parent.$parent.$parent.modalCloseList(item)
      },

      // format merubah angka ke currency 
    formatPrice(value) {
        let val = (value/1).toFixed().replace('.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>